<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-25 12:22:57
-->
<template>
  <div class="contain">
    <div class="header">
      <el-select
        v-model="year"
        placeholder="年份"
        @change="getSearch(year)"
        popper-class="select"
        clearable
      >
        <el-option
          v-for="item in yearList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="manageContent">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :inline="true"
        label-position="top"
      >
        <el-col :span="8">
          <el-form-item prop="entTel" label="年产值（万元）">
            <el-input
              v-model="ruleForm.outputValue"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="createBy" label="年营业收入（万元）">
            <el-input
              v-model="ruleForm.businessIncome"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="entWeb" label="出口总额（万元）">
            <el-input
              v-model="ruleForm.totalExport"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="smsTypes" label="实缴税收（万元）">
            <el-input
              v-model="ruleForm.taxRevenue"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="jbrTel" label="利润总额（万元）">
            <el-input
              v-model="ruleForm.totalProfit"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="smsTypes" label="工资总额（万元）">
            <el-input
              v-model="ruleForm.grossSalary"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="financialTel" label="研发经费总额（万元）">
            <el-input
              v-model="ruleForm.totalResearch"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="smsTypes" label="固定资产（万元）">
            <el-input
              v-model="ruleForm.fixAssets"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="telephone" label="资产总额（万元）">
            <el-input
              v-model="ruleForm.totalAssets"
              placeholder=""
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getManagementData } from '@api/corporateInteraction/enterprise'
import { toHtmlStr } from '@utils'
export default {
  props: {
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      toHtmlStr,
      year: '',
      yearList: [],
      ruleForm: {}
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getSearch('')
    this.year = new Date().getFullYear()
    for (let i = this.year - 4; i <= this.year; i++) {
      this.yearList.push({
        label: i,
        value: i
      })
    }
  },
  methods: {
    getSearch(num) {
      const params = {
        creditCode: this.creditCode,
        dataYear: num
      }
      getManagementData(params).then(res => {
        if (res.data.code === '0000') {
          const {
            outputValue,
            businessIncome,
            totalExport,
            taxRevenue,
            totalProfit,
            grossSalary,
            totalResearch,
            fixAssets,
            totalAssets
          } = res.data.data
          this.ruleForm = {
            outputValue,
            businessIncome,
            totalExport,
            taxRevenue,
            totalProfit,
            grossSalary,
            totalResearch,
            fixAssets,
            totalAssets
          }
          if (!num) {
            this.year = res.data.data.dataYear
          }

          for (let key in this.ruleForm) {
            this.ruleForm[key] = this.ruleForm[key] || '-'
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  height: 100%;
  .header {
    color: rgba(255, 255, 255, 100);
    font-size: 0.16rem;
    line-height: 0.36rem;
    /deep/.el-select {
      .el-input__inner {
        background: transparent;
        border: 1px solid rgba(46, 178, 236, 0.5);
        height: 0.32rem;
        color: rgba(199, 241, 255, 100);
      }
    }
    // &::before {
    //   content: '';
    //   vertical-align: middle;
    //   width: 0.03rem;
    //   height: 0.18rem;
    //   display: inline-block;
    //   margin-right: 0.1rem;
    //   background: #00fffe;
    // }
  }
  .manageContent {
    /deep/.el-form-item {
      line-height: 0.4rem;
      margin-bottom: 0;
    }
    /deep/ .el-form-item__label {
      color: rgba(0, 255, 254, 100);
      padding: 0;
    }
    /deep/ .el-col {
      height: 0.9rem;
    }
    /deep/ .el-input__inner {
      width: 4rem;
      background: transparent;
      border: 1px solid rgba(46, 178, 236, 0.5);
      height: 0.4rem;
      color: rgba(199, 241, 255, 100);
    }
  }
}
</style>
